import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
class GetAdDetailsAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {GetAdDetailsAdsService} deps.getAdDetailsAdsService
   */
  constructor({config, log, getAdDetailsAdsService}) {
    super()

    this._config = config
    this._log = log
    this._getAdDetailsAdsService = getAdDetailsAdsService
  }

  @tracer({metric: 'GetAdDetailsAdsUseCase#execute'})
  @inlineError
  async execute({adId, isPreview = false, expand}) {
    this._log('Getting Ad Details')

    const [getAdDetailsAdsServiceError, getAdDetailsAdsServiceResponse] = await this._getAdDetailsAdsService.execute({
      adId,
      expand,
      isPreview
    })

    return getAdDetailsAdsServiceError
      ? Promise.reject(getAdDetailsAdsServiceError)
      : getAdDetailsAdsServiceResponse.toJSON()
  }
}

export default GetAdDetailsAdsUseCase
